/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import EntryActions from 'actions/EntryActions';
import * as analytics from 'analytics/Analytics';
import BenchlingConfig from 'BenchlingConfig';
import DataConnector from 'connect/DataConnector';
import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import CloneModal from 'folder-items/CloneModal';
import ReviewConstants from 'notebook/reviews/ReviewConstants';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import getAllStructuredTablesInNote from 'notebook/structured-tables/util/getAllStructuredTablesInNote';
import VersionHistoryPanel from 'notebook/version-history/VersionHistoryPanel';
import {Version} from 'notebook/version-history/VersionHistoryTypes';
// @ts-expect-error
import EntryStore from 'stores/EntryStore';
import runModal from 'ui-library/runModal';

const fileStates = require('FileStates').default.get();

class EntryHistoryPanelConnector extends DataConnector<Props, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [EntryStore];

  enhanceProps(): EnhancedProps {
    return {versionState: this.entryStore().getVersionState(this.props.id)};
  }
}

interface Props {
  id: string;
  folderId: string;
  name: string;
  permissions?: any;
}
interface EnhancedProps {
  versionState: any;
}

class EntryHistoryPanel extends React.Component<Props & EnhancedProps> {
  constructor(props: Props & EnhancedProps) {
    super(props);
  }

  render(): JSX.Element {
    const versions: Array<Version> = this.props.versionState.versions.toReversed();

    const isLockedForReview = Array.from(ReviewConstants.LOCKED_STATUSES).includes(
      __guard__(EntryStore.getEntry(this.props.id).review, (x: any) => x.status)
    );
    const constainsProcessTables = containsProcessRelatedTables(EntryStore.getEntry(this.props.id));
    const disableResetToVersion =
      BenchlingConfig.ELN_DISABLE_ENTRY_REVERTS ||
      this.props.versionState.isLatest ||
      this.props.versionState.unsaved ||
      this.props.versionState.dirty ||
      !this.props.permissions.writable ||
      constainsProcessTables ||
      isLockedForReview;
    const disableDuplicateFromVersion = constainsProcessTables;
    return (
      <VersionHistoryPanel
        versions={versions}
        openVersionId={this.props.versionState.openVersionId}
        navigateAndSetOpenVersionId={this.openVersion}
        enableResetToVersion={!disableResetToVersion}
        resetToVersion={disableResetToVersion ? () => {} : this.resetToVersion}
        enableDuplicateFromVersion={!disableDuplicateFromVersion}
        duplicateFromVersion={disableDuplicateFromVersion ? () => {} : this.cloneFromVersion}
        versionParent={this.props.versionState.parent}
        navigateToVersionParent={this.navigateToVersionParent}
        unsaved={this.props.versionState.unsaved || this.props.versionState.dirty}
      />
    );
  }

  componentDidMount(): void {
    EntryActions.fetchVersions(this.props.id);
  }

  componentDidUpdate(prevProps: Props & EnhancedProps, prevState: any): void {
    if (
      prevProps.versionState.savedVersion !== this.props.versionState.savedVersion ||
      prevProps.id !== this.props.id
    ) {
      // Avoid flux nested-dispatch issues
      _.defer(() => {
        EntryActions.fetchVersions(this.props.id);
      });
    }
  }

  openVersion = (versionId: any): void => {
    analytics.trackEvent(ELN_ANALYTICS_ACTIONS.OPENED_OLD_ENTRY_VERSION, {entry_id: this.props.id});
    EntryActions.loadVersion(this.props.id, versionId);
  };

  resetToVersion = (): void => {
    analytics.trackEvent(ELN_ANALYTICS_ACTIONS.REVERTED_ENTRY_VERSION, {entry_id: this.props.id});
    EntryActions.resetToOpenVersion(this.props.id);
  };

  navigateToVersionParent = (): void => {
    const parent = this.props.versionState.parent;
    fileStates.openFolderItem(parent.id, {
      open: true,
      source: 'history-panel-component',
      versionId: parent.versionId,
    });
  };

  cloneFromVersion = (): void => {
    runModal(CloneModal, {
      modelType: ModelTypeConstants.ENTRY,
      id: this.props.id,
      versionId: this.props.versionState.openVersionId,
      initialName: `${this.props.name} (new)`,
      initialFolderId: this.props.folderId,
    });
  };
}

export default EntryHistoryPanelConnector.connect(EntryHistoryPanel);

function __guard__(value: any, transform: any): any {
  return value != null ? transform(value) : undefined;
}

function containsProcessRelatedTables(entry: any): boolean {
  if (entry.note != null) {
    const structuredTables = getAllStructuredTablesInNote(entry.note);
    return structuredTables.some(
      (structuredTable) =>
        structuredTable.kind === StructuredTableKind.PROCESS_TASK ||
        structuredTable.kind === StructuredTableKind.PROCESS_OUTPUT
    );
  }
  return false;
}
